import axios from "axios";
import * as qs from 'qs';

class LeadDataService {
  /**
   * /app/getleaddata.php
   * @param leadId {login}
   * @return {Promise<any>}
   */
  getLead(leadId) {
    return axios.post('/app/getleaddata.php', qs.stringify({login: leadId}));
  }

  getLeadList() {
    return axios.post('/app/list.php'); //todo check
  }

  addNewLead() {
    return axios.post('/newlead.php'); //todo check
  }

  editLead() {
    return axios.post('/app/editlead.php'); //todo check
  }

  addComment(query) {
    return axios.post('/app/comments/addcomment.php', qs.stringify(query)); //todo check
  }

  changeAssign() {
    return axios.post('/app/changeassing.php'); //todo check
  }

  searchLead() {
    return axios.post('/app/search.php'); //todo check
  }

  /**
   * @param query
   * @return {Promise<any>}
   */
  call(query) {
    return axios.post('/app/call.php', qs.stringify(query));
  }

  /**
   * @param query
   * @return {Promise<any>}
   */
  changeDepositStatus(query) {
    return axios.post('/app/changedepstatus.php', qs.stringify(query))
  }

  /**
   * @param query
   * @return {Promise<AxiosResponse<any>>}
   */
  getPrograms(query) {
    return axios.post('/app/programs.php', qs.stringify(query))
  }

  /**
   * @param action
   * @return {Promise<AxiosResponse<any>>}
   */
  getTypesList(action = 'listtypes') {
    return axios.get('/app/programs.php?action='+action)
  }
}

export default new LeadDataService();
